<template>
  <div class="lz-dialog">
    <el-dialog v-model="dialogShow" v-if="dialogShow" :title="obj.dialogTitle" :width="obj.dialogWidth"
               :close-on-click-modal="false" :close-on-press-escape="false" :before-close="close" draggable>
      <slot></slot>
      <template #footer>
                <span v-if="obj.dialogIsFooter" class="dialog-footer">
                    <el-button class="btn-mixins-clear-default" v-if="obj.dialogCloseBtnText"
                               @click="close">{{ obj.dialogCloseBtnText }}</el-button>
                    <el-button class="btn-mixins dia-suc" v-if=" obj.dialogSuccessBtnText"
                               @click="success">{{ obj.dialogSuccessBtnText }}</el-button>
                </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {computed, watch} from 'vue'

export default {
  props: {
    dialogObject: {
      default() {
        return {}
      },
      type: Object
    }
  },
  emits: ['dialogClose', 'dialogSuccess'],

  setup(props, ctx) {
    // const dialogObj = reactive(inject('dialogObj'))
    // 处理props的数据 重新定义 dialogVisible
    const dialogShow = computed({
      get() {
        // getter
        return props.dialogObject.dialogVisible
      },
      set(val) {
        // console.log(val)
        return val
      }
    })
    let obj = {
      dialogTitle: props.dialogObject.title || '标题',
      dialogWidth: props.dialogObject.width || '30%',
      dialogCloseBtnText: props.dialogObject.closeBtnText || '取消',
      dialogSuccessBtnText: props.dialogObject.successBtnText || '成功',
      dialogIsFooter: props.dialogObject.isFooter || false
    }

    watch(props.dialogObject, (newValue, oldValue) => {
          obj.dialogTitle = newValue.title;
        },
        {immediate: true, deep: true}
    );

    const close = () => {
      ctx.emit('dialogClose', false, 'close')
    }
    const success = () => {
      ctx.emit('dialogSuccess', false, 'success')
    }
    return {obj, dialogShow, close, success}
  }
}
</script>
<style lang="scss" scope>
.lz-dialog {
  .dia-suc {
    margin-left: 16px !important;
  }
}
</style>